import type { FC, ReactNode } from "react";
import { Box, type BoxProps, Column, ErrorIcon, Text } from "@hightouch/htui";

export type ChartErrorStateProps = {
  title?: string;
  message?: ReactNode;
} & Omit<BoxProps, "children" | "title">;

export const ChartErrorState: FC<ChartErrorStateProps> = ({
  title = "Failed to load",
  message = "Check that your chart is configured correctly.",
  ...boxProps
}) => (
  <Column
    align="center"
    justify="center"
    textAlign="center"
    gap={2}
    p={4}
    width="100%"
    height="100%"
    {...boxProps}
  >
    <Box as={ErrorIcon} color="icon.danger" boxSize={12} />
    <Column gap={1} align="center">
      <Text size="lg" fontWeight="semibold" color="text.primary">
        {title}
      </Text>
      {message && <Text color="text.disabled">{message}</Text>}
    </Column>
  </Column>
);
